import React, {useState, useRef} from 'react';
import {Button, Input, Space, Table, Tag, Skeleton, Card, Modal, Form, Select, message} from 'antd';
import {SearchOutlined, CheckCircleOutlined, PlusOutlined} from '@ant-design/icons';
import Highlighter from 'react-highlight-words';
import Title from "../../../components/Title";
import {useSelector} from "react-redux";
import {Link, useNavigate} from "react-router-dom";
import moment from "moment";
import {
    useGetGroupsQuery,
    useNewGroupMutation,
} from "../../../slices/rootApiSlices/groupApiSlice";

const {Option} = Select;

const Index = () => {

    const [form] = Form.useForm();
    const navigate = useNavigate();
    const {user} = useSelector((state) => state.auth);
    const {data, error, isLoading, refetch} = useGetGroupsQuery(user?.token);
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [isActive, setActive] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
    const searchInput = useRef(null);
    const [handleAdd, {isLoading: addLoading}] = useNewGroupMutation();
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [loading, setLoading] = useState(false);


    const addHandle = async () => {
        const newGroup = {
            description,
            title,
            isActive: form.getFieldValue("isActive"),
        };
        try {
            setLoading(true);
            const res = await handleAdd({token: user?.token, data: newGroup}).unwrap();
            setIsModalVisible(false);
            refetch();
            setTimeout(() => {
                navigate(`/settings/groups/${res?.group?.id}`);
                setLoading(false);
            }, 1000);
        } catch (e) {
            message.error('işlem başarısız');
            setIsModalVisible(false);
            setLoading(false);
        }
    };


    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    };

    const handleReset = (clearFilters) => {
        clearFilters();
        setSearchText('');
    };

    const getColumnSearchProps = (dataIndex) => ({
        filterDropdown: ({setSelectedKeys, selectedKeys, confirm, clearFilters, close}) => (
            <div style={{padding: 8}} onKeyDown={(e) => e.stopPropagation()}>
                <Input
                    ref={searchInput}
                    placeholder={`Ara ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{marginBottom: 8, display: 'block'}}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                        icon={<SearchOutlined/>}
                        size="small"
                        style={{width: 90}}
                    >
                        Ara
                    </Button>
                    <Button onClick={() => clearFilters && handleReset(clearFilters)} size="small" style={{width: 90}}>
                        Sıfırla
                    </Button>
                    <Button
                        type="link"
                        size="small"
                        onClick={() => {
                            confirm({closeDropdown: false});
                            setSearchText(selectedKeys[0]);
                            setSearchedColumn(dataIndex);
                        }}
                    >
                        Filtrele
                    </Button>
                    <Button type="link" size="small" onClick={() => close()}>
                        Kapat
                    </Button>
                </Space>
            </div>
        ),
        render: (text) =>
            searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{backgroundColor: '#ffc069', padding: 0}}
                    searchWords={[searchText]}
                    autoEscape
                    textToHighlight={text ? text.toString() : ''}
                />
            ) : (
                text
            ),
    });

    const columns = [
        {
            title: 'Grup Adı',
            dataIndex: 'title',
            key: 'title',
            width: '5%',
            ...getColumnSearchProps('title'),
            render: (text, row) => (
                <Link style={{justifyContent: "center"}} to={`/settings/groups/${row.id}`}>
                    {text ? text : "no name"}
                </Link>
            ),
        },
        {
            title: 'Açıklama',
            dataIndex: 'description',
            key: 'description',
            width: '7%',
            ...getColumnSearchProps('description'),
        },
        {
            title: 'Oluşturulma Tarihi',
            dataIndex: 'createdAt',
            key: 'createdAt',
            width: '10%',
            ...getColumnSearchProps('createdAt'),
            render: (text) => <span>{moment(text).format('DD-MM-YYYY HH:mm:ss')}</span>,
        },
        {
            title: 'Durumu',
            key: 'isActive',
            width: '5%',
            responsive: ['lg'],
            dataIndex: 'isActive',
            sorter: (a, b) => a.isActive.length - b.isActive.length,
            render: (status) => (
                <span style={{textAlign: "center"}}>
          {status === true ? (
              <Tag
                  style={{padding: 3, paddingInline: 5, textAlign: "center"}}
                  icon={<CheckCircleOutlined/>}
                  color='green'
                  key={status}
              >
                  Aktif
              </Tag>
          ) : (
              <Tag color='volcano' key={status}>
                  Servis Dışı
              </Tag>
          )}
        </span>
            ),
        },
    ];

    const locale = {
        emptyText: 'Grup bulunamadı. Lütfen grup ekleyin.',
    };

    // Modal handlers
    const showModal = () => {
        setIsModalVisible(true);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    return (
        <Skeleton loading={isLoading || loading || addLoading}>
            <Card
                type="inner"
                size="small"
                title="Grup Listesi"
                extra={
                    <Button type="primary" size="small" icon={<PlusOutlined/>} onClick={showModal}>
                        Yeni Grup
                    </Button>
                }
            >
                <Title title="Octoopi Cocpit | Grup Listesi" description="Mertech Arge A.Ş Grup Listesi"/>
                <Table
                    locale={locale}
                    rowKey="id"
                    loading={isLoading}
                    bordered={true}
                    size="small"
                    columns={columns}
                    dataSource={data?.data}
                    error={error}
                />
            </Card>
            <Modal
                title="Yeni Grup Ekle"
                open={isModalVisible}
                onOk={addHandle}
                onCancel={handleCancel}
                okText="Kaydet"
                cancelText="Vazgeç"
            >
                <Form
                    form={form}
                    layout="vertical"
                    name="add-group"
                >
                    <Form.Item
                        label="Grup Adı"
                        name="title"
                        onChange={e => setTitle(e.target.value)}
                        value={title}
                    >
                        <Input
                            placeholder="Grup adı giriniz"
                        />
                    </Form.Item>
                    <Form.Item
                        label="Açıklama"
                        name="description"
                        onChange={e => setDescription(e.target.value)}
                        value={description}
                    >
                        <Input placeholder="Açıklama giriniz"/>
                    </Form.Item>
                    <Form.Item
                        label="Durum"
                        name="isActive"
                        rules={[
                            {
                                required: true,
                                message: 'lütfen durum giriniz !',
                            },
                        ]}
                        value={isActive}
                    >
                        <Select
                            onChange={(e) => setActive({...isActive})}
                            placeholder="Durum seçiniz.."
                            allowClear
                        >
                            <Option value={true}>Aktif</Option>
                            <Option value={false}>Pasif</Option>
                        </Select>
                    </Form.Item>
                </Form>
            </Modal>
        </Skeleton>
    );
};

export default Index;
